module.exports = __webpack_public_path__ + "static/img/1.c7e07fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/zlgl/1.jpg
// module id = +Vx2
// module chunks = 0